import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { registerTerminalContribution } from '../../../terminal/browser/terminalExtensions.js';
import { TerminalInlineChatAccessibleViewContribution } from './terminalChatAccessibleView.js';
import { TerminalChatController } from './terminalChatController.js';
import './terminalChatActions.js';
import { TerminalChatAccessibilityHelpContribution } from './terminalChatAccessibilityHelp.js';

registerTerminalContribution(TerminalChatController.ID, TerminalChatController, false);
registerWorkbenchContribution2(TerminalInlineChatAccessibleViewContribution.ID, TerminalInlineChatAccessibleViewContribution, 4 );
registerWorkbenchContribution2(TerminalChatAccessibilityHelpContribution.ID, TerminalChatAccessibilityHelpContribution, 4 );
